import { API_CONFIG } from '../utils/constants';

export interface SubmitRequest {
  data: (string | null)[];
}

export interface SubmitResponse {
  submissionid: string;
  time_created: string;
}

class SimpleApiService {
  private functionKey: string = '';

  setFunctionKey(key: string): void {
    this.functionKey = key;
  }

  getFunctionKey(): string {
    return this.functionKey;
  }

  async submitData(data: (string | null)[]): Promise<SubmitResponse> {
    const url = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.SUBMIT_SCORE}?code=${this.functionKey}`;
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ data }),
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json();
  }

  async getScores(submissionId: string, all: boolean = false): Promise<any> {
    const allParam = all ? '?all=true' : '';
    const codeParam = all ? `&code=${this.functionKey}` : `?code=${this.functionKey}`;
    const url = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.GET_SCORE}/${submissionId}${allParam}${codeParam}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json();
  }
}

export const apiService = new SimpleApiService();